// Holds the identifier/password entered on Login.js or LandingPage.js while
// a 2FA code is being collected, so the pending submission survives a
// same-session remount of the login page (e.g. React re-mounting the
// component, or navigating away and back before the code is entered).
//
// This used to be written to localStorage as plaintext (under the
// 'loginFormData' key) alongside the non-secret 'requires2FA'/
// 'rememberedIdentifier' flags. localStorage is unencrypted, persists
// indefinitely (survives tab/browser close, unlike sessionStorage), and is
// readable by any script on the origin (XSS) or via devtools/browser
// profile inspection - so a user who started a 2FA login on a shared
// computer and then abandoned the flow (closed the tab, walked away) left
// their plaintext password sitting on disk indefinitely.
//
// A plain module-scoped variable gives the same "survives a remount"
// behavior for the lifetime of the page/tab, without ever touching disk -
// it's cleared on a real page reload, which is the correct behavior for a
// value this sensitive.
let pendingCredentials = null;

export function getPendingLoginCredentials() {
  return pendingCredentials;
}

export function hasPendingLoginCredentials() {
  return pendingCredentials !== null;
}

export function setPendingLoginCredentials(identifier, password) {
  pendingCredentials = { identifier, password };
}

export function clearPendingLoginCredentials() {
  pendingCredentials = null;
}
